import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Switch from 'react-switch'

const ToggleSwitch = ({ isChecked, onChange, stopPropagation = false }) => {
  const [checked, setChecked] = useState(isChecked || false)
  const { t } = useTranslation()

  useEffect(() => {
    setChecked(isChecked)
  }, [isChecked])

  return (
    <div>
      <Switch
        aria-label={checked ? t('formlabel.makePrivate') : t('formlabel.makePublic')}
        onChange={(chked, e) => {
          if (stopPropagation) {
            e.stopPropagation()
          }
          setChecked(!checked)
          onChange(!checked)
        }}
        checked={checked}
        onColor='#00bfa6'
        uncheckedIcon={false}
        checkedIcon={false}
        height={24}
        width={54}
        handleDiameter={20}
      />
    </div>
  )
}

export default ToggleSwitch
